import { FC, useContext, useEffect, useRef } from "react";
import MapFormContext from "../../contexts/data/MapFormContext";
import SpeciesFormsContext from "../../contexts/data/SpeciesFormsContext";
import AlertContext, { IAlert } from "../../contexts/styles/AlertContext";
import { useScopedField } from "@ngt/forms-core";
import { AlertTitle } from "@mui/material";

const LocationAlert: FC = () => {
    const { 
        drawerOpen,  
        drawerMaximised, 
        accuracyWarning
    } = useContext(MapFormContext);
    const { selectedForm } = useContext(SpeciesFormsContext);
    const { addAlert, removeAlert } = useContext(AlertContext);
    const { state: { value: latitude }, context: { setValue: setLatitude } } = useScopedField(selectedForm?.name + ".Latitude", { value: true });
    const { state: { value: longitude }, context: { setValue: setLongitude }  } = useScopedField(selectedForm?.name + ".Longitude", { value: true });
    
    const alertRef = useRef<IAlert>();

    useEffect(() => {
        if (drawerOpen && drawerMaximised && accuracyWarning && selectedForm && !alertRef.current && !latitude && !longitude) {
            // const retryGeolocation = () => {
            //     if ("geolocation" in navigator) {
            //         navigator.geolocation.getCurrentPosition(
            //             (position: GeolocationPosition) => {
            //                 if (position.coords.accuracy <= 100) {
            //                     setLatitude(position.coords.latitude);
            //                     setLongitude(position.coords.longitude);
            //                 }
            //                 else {
            //                     setLatitude(undefined);
            //                     setLongitude(undefined);
            //                     addAlert({
            //                         content: <AlertTitle>
            //                                     Failed to get location.
            //                                 </AlertTitle>,
            //                         dismissable: true,
            //                         severity: 'error',
            //                         timeout: 1000
            //                     });
            //                 }
            //             },
            //             () => {
            //                 addAlert({
            //                     content: <AlertTitle>
            //                                 Failed to get location.
            //                             </AlertTitle>,
            //                     dismissable: true,
            //                     severity: 'error',
            //                     timeout: 1000
            //                 });
            //             },
            //             {
            //                 enableHighAccuracy: true
            //             }
            //         );
            //     }
            // };

            const alert: IAlert = {
                content: (
                    <>
                        <AlertTitle>
                                We are having trouble getting an accurate location. Please enter your location manually.
                        </AlertTitle>
                        {/* <Button color="inherit" onClick={retryGeolocation}>Retry</Button> */}
                    </>
                ),
                dismissable: false,
                severity: 'error',
                timeout: undefined
            };
            alertRef.current = alert;
            addAlert(alert);
        }
    }, [
        accuracyWarning, 
        drawerOpen, 
        drawerMaximised, 
        selectedForm, 
        addAlert, 
        alertRef, 
        setLatitude, 
        setLongitude, 
        latitude, 
        longitude
    ]);

    useEffect(() => {
        if (latitude && longitude && alertRef.current) {
            removeAlert(alertRef.current)
            alertRef.current = undefined;
        }
    }, [latitude, longitude, alertRef, removeAlert]);
    
    useEffect(() => {
        if (alertRef.current && (!drawerMaximised || !drawerOpen)) {
            removeAlert(alertRef.current);
            alertRef.current = undefined;
        }
    }, [alertRef, removeAlert, drawerMaximised, drawerOpen]);

    return null;
}; 

export default LocationAlert;